// AuthProvider.js
"use client"

import { SessionProvider, signOut } from "next-auth/react"
import { apiFetch } from "@/lib/api"

apiFetch._onUnauthorized = () => signOut({ callbackUrl: "/login" });

export default function AuthProvider({ children }) {
  return (
    <SessionProvider refetchOnWindowFocus={true} >
      {children}
    </SessionProvider>
  )
}
